import React from "react";
import {useFieldArray} from "react-hook-form";
import NestedArray from "./nestedFieldArray";
import NestedArrayLocationGroup from "./nestedLocationGroupFieldArray";
import {FormDialog} from "../../../api/types/generic";
import {LocationGroupProductCodeModelFE} from "../../../api/types/locationGroupProductCode";
import {Button, Card, CardContent, CardHeader, Grid, IconButton, useTheme} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CardContainer from "../../../common/components/CardContainer";
import {Delete} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import {productCodesAtom} from "../../../state/locationGroupProductCodesRecoil";

export default function Fields({
                                   control,
                                   register,
                                   setValue,
                                   getValues,
                                   formDialog,
                                   canAdd,
                                   handleChangeProductCode,
                                   locationGroupList,
                                   handleChangeLocationGroup,
                                   label
                               }: {
    control: any,
    register: Function,
    setValue: Function,
    getValues: Function,
    formDialog: FormDialog | null,
    /**
     * LPP-24713: abilitazione del pulsante "aggiungi combinazione".
     * Il componente e' condiviso da form con modelli diversi (il gruppo si chiama
     * exceptionList nelle eccezioni, excessGroup nelle franchigie): la form passa
     * direttamente l'esito del controllo. Se omessa, resta il comportamento storico
     * basato sul campo exceptionList.
     */
    canAdd?: boolean,
    handleChangeProductCode: Function,
    locationGroupList: { [key: number]: LocationGroupProductCodeModelFE[] },
    handleChangeLocationGroup: Function,
    label: string
}) {
    const {fields, remove} = useFieldArray({
        control,
        name: "associations"
    });

    const [productCodeList] = useRecoilState(productCodesAtom);

    const theme = useTheme();

    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <>
            {fields.map((item, index) => {
                return (
                    <Grid container spacing={2} p={2} key={item.id}>
                        <Grid item xs={12} sm={12}>
                            <Card>
                                <CardHeader
                                    sx={{backgroundColor: theme.palette.neutral.bright}}
                                    action={
                                        <IconButton aria-label="settings" color={"accent"}
                                                    onClick={() => remove(index)}>
                                            <Delete/>
                                        </IconButton>
                                    }
                                    title={`${t("pricing:exceptionListProductCodeLocationGroup.form.labels.exceptionList")}: ${label}`}
                                />

                                <CardContent>
                                    <Grid container spacing={2} rowSpacing={3}>
                                        <Grid item xs={12} md={3}>
                                            <NestedArray
                                                nestIndex={index}
                                                {...{
                                                    control,
                                                    register,
                                                    formDialog,
                                                    handleChange: handleChangeProductCode,
                                                    options: productCodeList || [],
                                                    name: "productCode",
                                                    getValues
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <NestedArrayLocationGroup
                                                nestIndex={index}
                                                {...{
                                                    control,
                                                    register,
                                                    formDialog,
                                                    options: locationGroupList[index] || [],
                                                    handleChange: handleChangeLocationGroup,
                                                    name: "locationGroup",
                                                    getValues
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                );
            })}
            <CardContainer>
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent={"center"} alignItems={"center"}>
                        <Grid item>
                            <Button size={"icon"}
                                    color={"accent"}
                                    onClick={() => {
                                        setValue("associations", [
                                            ...(getValues().associations || []),
                                            {
                                                locationGroup: [],
                                                productCode: []
                                            }
                                        ]);
                                    }}
                                    disabled={canAdd !== undefined ? !canAdd : !getValues().exceptionList}
                            >
                                <AddIcon/>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContainer>
        </>
    );
}
